import React, { useEffect, useState } from 'react'
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import useSearchMember from '../../../hooks/fetchUsers'
import { renewSubscriptionSchema } from './renewSubscriptionSchema'
import { CustomInputSearch } from '../../dashboard/subContent/searchContainer/CustomInputSearch'
import { useForm } from 'react-hook-form'
import logger from '../../../utils/logger'
import { MemberService } from '../../../services/MemberService'
import apiClient from '../../../helper/Axios/axiosHelper'
import { dateFormat } from '../../../helper/dataFormat'
import { RenewCard } from '../../common/custom-subscriptionCard/RenewCard'
import { subscriptionStatesMapping } from './Renew-Alert/subscriptionStateModel'
import { RenewAlert } from './Renew-Alert/RenewAlert'
import { motion } from 'framer-motion'

export const RenewSubscription = () => {

    const variants = {
        hidden: { opacity: 0, x: 20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } }
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        document.title = 'TPA® Admin - Renovar Miembro'
    }, [])

    const [data, setData] = useState(null)
    const [objectToSend, setObjectToSend] = useState(null)

    const { register, handleSubmit } = useForm({})


    const onSubmit = (data) => {
        logger.info('data: ', data)
        const memberData = async () => {
            try {
                const response = await MemberService.getMemberEnrollment(data.Email)
                logger.warn('HAY RESPONSE: ', response)

                if (response.data[0]) {
                    setData(response.data[0])

                    const objectToSend = {
                        enrollmentId: response.data[0]?.id,
                        memberId: response.data[0]?.memberId,
                    }

                    setObjectToSend(objectToSend)
                }
                
            } catch (error) {
                logger.error('error al renovar usuario:', error);

            }
        }

        memberData()


    }

    let schema = renewSubscriptionSchema

    return (
        <>



            <div className='mt-4'>
                <form
                    className="container aSearch-container mb-3"
                    onSubmit={handleSubmit(onSubmit)}>

                    <CustomInputSearch
                        key={schema[0].name}
                        register={register}
                        name={schema[0].name}
                        type={schema[0].type}
                        placeholder={schema[0].labelTitle}
                    />

                    <button
                        type='submit'
                        className="btn-Asearch2 btn btn-success"
                    >
                        <span>Buscar</span>
                    </button>
                </form>

            </div>

            {data &&
                <motion.div
                    className="motionDiv d-flex justify-content-center"
                    variants={variants}
                    initial="hidden"
                    animate="visible"
                >

                    <div className='subscriptionCard row g-3 w-100'>
                        <RenewCard
                            handleShow={handleShow}
                            handleClose={handleClose}
                            show={show}
                            objectToSend={objectToSend}
                            data={data}
                            subscriptionModel={subscriptionStatesMapping}
                            />

                    </div>

                </motion.div>
            }



        </>



    )
}
